import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    id?: string
    eyebrow: string
    title: ReactNode
    description?: ReactNode
    align?: 'left' | 'center'
    inverted?: boolean
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    id,
    eyebrow,
    title,
    description,
    align = 'left',
    inverted = false,
    className
}): ReactNode => {
    return (
        <div className={cn('max-w-2xl', align === 'center' && 'mx-auto text-center', className)}>
            <p className={cn('text-xs font-bold uppercase tracking-[0.22em]', inverted ? 'text-aqua' : 'text-aqua-deep')}>
                {eyebrow}
            </p>

            <h2
                id={id}
                className={cn(
                    'mt-3 font-heading text-[2.6rem] font-bold uppercase leading-[0.92] tracking-tight sm:text-5xl lg:text-[3.6rem]',
                    inverted ? 'text-white' : 'text-ink'
                )}
            >
                {title}
            </h2>

            {description && (
                <p className={cn('mt-5 text-lg leading-relaxed', inverted ? 'text-white/70' : 'text-muted-foreground')}>
                    {description}
                </p>
            )}
        </div>
    )
}
